export default "__VITE_ASSET__3193ab22__"